import dayjs from 'dayjs';
import { LICENSE_STATUS } from '../constants/licenseConstants';

export const getStatus = (expireAt) => {
    const now = dayjs();
    const expiry = dayjs(expireAt);

    if (expiry.isBefore(now)) {
        return LICENSE_STATUS.EXPIRED;
    } else if (expiry.diff(now, 'days') <= 30) {
        return LICENSE_STATUS.EXPIRING;
    }
    return LICENSE_STATUS.ACTIVE;
};

export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (error) {
        return false;
    }
};
